import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    budget: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Full name is required';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    
    if (!formData.message.trim()) {
      newErrors.message = 'Project details are required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      console.log('Attempting to send email with data:', formData);
      
      // Send directly using emailjs.send
      const result = await emailjs.send(
        'service_uu4fmf5',  // Your service ID
        'template_vyrjxv9', // Your template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          company: formData.company || 'Not provided',
          service: formData.service || 'Not specified',
          budget: formData.budget || 'Not specified',
          message: formData.message,
          reply_to: formData.email
        },
        'QexwyU3PKXsENvxb4' // Your public key
      );
      
      console.log('Email sent successfully:', result);
      alert('Thank you for your message! We\'ll get back to you within 24 hours.');
      
      setFormData({
        name: '',
        email: '',
        company: '',
        service: '',
        budget: '',
        message: ''
      });
      setErrors({});
      
    } catch (error) {
      console.error('Detailed error:', error);
      alert(`Error: ${error.text || error.message || 'Failed to send message'}. Please contact us directly at info@trailblazedigital.net`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <main className="contact-main">
        <section className="contact-hero">
          <div className="contact-hero-content">
            <h1>Let's Start Something Amazing</h1>
            <p>Ready to transform your digital presence? We'd love to hear from you.</p>
          </div>
        </section>
        <div className="container" style={{ position: 'relative', zIndex: 10 }}>
          <div className="contact-content">
            <div className="contact-form-section">
              <h2>Tell Us About Your Project</h2>
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className={errors.name ? 'error' : ''}
                      placeholder="Enter your full name"
                      autoComplete="name"
                      required
                      disabled={isSubmitting}
                    />
                    {errors.name && <span className="error-message">{errors.name}</span>}
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={errors.email ? 'error' : ''}
                      placeholder="your.email@example.com"
                      autoComplete="email"
                      required
                      disabled={isSubmitting}
                    />
                    {errors.email && <span className="error-message">{errors.email}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="company">Company Name</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Your company name (optional)"
                      autoComplete="organization"
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="service">Service Needed</label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className={formData.service ? 'has-value' : ''}
                      disabled={isSubmitting}
                    >
                      <option value="">Select a service</option>
                      <option value="advertising">UI/UX Design for Apps</option>
                      <option value="website">Website Design & Development</option>
                      <option value="content">App Development</option>
                      <option value="branding">Branding & Graphic Design</option>
                      <option value="full-service">Full Service Package</option>
                      <option value="consultation">Consultation Only</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Project Details *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    className={errors.message ? 'error' : ''}
                    placeholder="Tell us about your goals, timeline, and any specific requirements..."
                    required
                    disabled={isSubmitting}
                  ></textarea>
                  {errors.message && <span className="error-message">{errors.message}</span>}
                </div>

                <button type="submit" className="btn-primary submit-btn" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send'}
                </button>
              </form>
            </div>

            <div className="contact-info-section">
              <h2>Get In Touch</h2>
              
              <div className="contact-methods">
                <div className="contact-method">
                  <h3>Send an Email</h3>
                  <p>commissions@trailblazedigital.net</p>
                  <p className="method-note">We respond within 24 hours</p>
                </div>

                <div className="contact-method">
                  <h3>Talk to an expert</h3>
                  <p>+90 (548) 834 2265</p>
                  <p className="method-note">Mon-Fri, 9AM-6PM EST</p>
                </div>
              </div>

              <div className="response-promise">
                <h3>Our Promise</h3>
                <ul>
                  <li>✓ Response within 24 hours</li>
                  <li>✓ Free initial consultation</li>
                  <li>✓ Custom proposal within 3 business days</li>
                  <li>✓ No obligation to proceed</li>
                </ul>
              </div>

              <div className="social-links">
                <h3>Follow Us</h3>
                <div className="social-icons">
                  <a href="https://www.instagram.com/trailblaze.digital/" aria-label="Instagram">Instagram</a>
                  <a href="https://www.linkedin.com/company/trailblaze-digital-ltd/" aria-label="LinkedIn">LinkedIn</a>
                  <a href='https://www.facebook.com/profile.php?id=61577960885624' aria-label="Facebook">Facebook</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Contact;